module.exports = __webpack_public_path__ + "static/media/jcps-mechanical-ltd.777d4094.png";